<template>
  <div id="app">
    <router-view v-if="$route.meta.fullscreen"/>
    <template v-else>
      <Header></Header>
      <router-view/>
      <Footer></Footer>
      <GoTop></GoTop>
    </template>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue